export default __webpack_public_path__ + "static/media/lig4.062063aa.png";